module.exports = __webpack_public_path__ + "img/1440-560.84dcba63.png";